import { useState } from "react";
import { EventBadge } from "../../components/EventBadge";
import type { OperationsSnapshot, TaskStatus, WorkBlock, WorkTask } from "../../domain/operations";
import { TaskRow } from "./TaskRow";
import { TimeRail } from "./TimeRail";

export function CompactBlock({ block, tasks, snapshot, onStatus }: {
  block: WorkBlock;
  tasks: WorkTask[];
  snapshot: OperationsSnapshot;
  onStatus: (id: string, status: TaskStatus, blockerNote?: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const complete = tasks.filter((task) => task.status === "complete").length;
  const eventIds = [...new Set(tasks.map((task) => task.eventId))];
  return (
    <article className={`work-block ${block.icon === "reset" ? "reset-block" : ""}`}>
      <div className={`compact-block ${open ? "expanded" : ""}`}>
        <TimeRail block={block} />
        <div className="block-title">
          <div className={`location-icon ${block.icon}`}>{block.icon === "transport" ? "⇥" : block.icon === "reset" ? "↻" : "⌂"}</div>
          <div>
            <h3>{block.title}</h3>
            <p>{block.timeframe} · {block.location}</p>
            <div className="event-pills">{eventIds.map((id) => { const event = snapshot.events.find((item) => item.id === id); return event ? <EventBadge key={id} compact event={event} /> : null; })}</div>
          </div>
        </div>
        <div className="compact-metric"><strong>{complete} / {tasks.length}</strong><span>tasks complete</span></div>
        <div className="staff-group">{block.staffIds.slice(0, 3).map((id) => { const staff = snapshot.staff.find((item) => item.id === id); return staff ? <span className="mini-avatar" key={id}>{staff.initials}</span> : null; })}</div>
        <button className="expand-button" onClick={() => setOpen((current) => !current)} aria-expanded={open} aria-label={`${open ? "Collapse" : "Expand"} ${block.title}`}>{open ? "⌃" : "⌄"}</button>
      </div>
      {open && (
        <div className="task-table" role="table" aria-label={`${block.title} tasks`}>
          {tasks.map((task) => <TaskRow key={task.id} task={task} snapshot={snapshot} onStatus={onStatus} />)}
        </div>
      )}
    </article>
  );
}
